import { Component, forwardRef, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileExplorerComponent } from '@app/shared/components/files/file-explorer/file-explorer.component';
import { FolderContext } from '@app/shared/types/models/files/explorer-folder.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

export interface FileExplorerMoveDialogData {
  context: FolderContext;
}

/** Chooses a destination through the shared browser; never performs a write. */
@Component({
  selector: 'proffeo-file-explorer-move-dialog',
  templateUrl: './file-explorer-move-dialog.component.html',
  imports: [forwardRef(() => FileExplorerComponent), UiDialogComponent, TranslatePipe]
})
export class FileExplorerMoveDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<FileExplorerMoveDialogComponent, string>);
  protected readonly data = inject<FileExplorerMoveDialogData>(MAT_DIALOG_DATA);
  protected selectFolder(folderId: string): void {
    this.dialogRef.close(folderId);
  }
}
